"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calendar_modal_1 = require("./calendar.modal");
var calendar_week_component_1 = require("./calendar-week.component");
var month_component_1 = require("./month.component");
var calendar_component_1 = require("./calendar.component");
var month_picker_component_1 = require("./month-picker.component");
exports.CALENDAR_COMPONENTS = [
    calendar_modal_1.CalendarModal,
    calendar_week_component_1.CalendarWeekComponent,
    month_component_1.MonthComponent,
    calendar_component_1.CalendarComponent,
    month_picker_component_1.MonthPickerComponent
];
//# sourceMappingURL=index.js.map